<template>
  <div class="wrapper widget-short-form">
    <h1>Vehicle Donation Request</h1>
    <form v-if="state === 'form'" method="POST">
      <div class="widget-col col">
        <p>Please fill out the following information to donate your vehicle.</p>
        <p>*All fields are required (except VIN)</p>
        <chc-input v-model="data.first_name" :error="errors.first_name" label="First Name" :required="true"></chc-input>
        <chc-input v-model="data.last_name" :error="errors.last_name" label="Last Name" :required="true"></chc-input>
        <chc-input v-model="data.mobile_phone" :error="errors.mobile_phone" label="Mobile Phone Number" :required="!data.no_mobile"></chc-input>
        <chc-checkbox v-model="data.no_mobile" label="I don't have a mobile phone"></chc-checkbox>
        <p v-if="data.no_mobile">A mobile phone number is helpful in contacting you to coordinate the vehicle pickup. If you don't have a mobile phone number please provide the best phone number to reach you.</p>
        <chc-input v-if="data.no_mobile" v-model="data.phone" :error="errors.phone" label="Phone Number" :required="true"></chc-input>
        <div class="field">
          <div class="radio-option" v-if="data.no_mobile">
            <input v-if="data.no_mobile" type="radio" name="phone_type" id="home" value="home" v-model="data.phone_type">
            <label v-if="data.no_mobile" class="inline-label" for="home">This is a home phone</label>
          </div>
          <div class="radio-option" v-if="data.no_mobile">
            <input v-if="data.no_mobile" type="radio" name="phone_type" id="work" value="work" v-model="data.phone_type">
            <label v-if="data.no_mobile" class="inline-label" for="work">This is a work phone</label>
          </div>
        </div>
        <chc-input v-model="data.email" :error="errors.email" label="Email" :required="true"></chc-input>
        <chc-input v-model="data.charity_id" :error="errors.charity_id" label="Select Charity" :required="true"
                       :autoCompleteValues="$store.state.summary.charities_active" format="combo"></chc-input>
        <chc-input v-model="data.vin" :error="errors.vin" label="VIN"
                         @blur="pullVin"></chc-input>
        <p v-if="loadingVin">Retrieving your vehicle info... Please Wait.</p>
        <chc-input v-model="data.vehicle_year" :error="errors.vehicle_year" label="Vehicle Year" :isLoading="loadingVin" ref="vehicleYear" :required="true"></chc-input>
        <chc-input v-model="data.vehicle_make" :error="errors.vehicle_make" label="Vehicle Make" :isLoading="loadingVin" ref="vehicleMake" :required="true"></chc-input>
        <chc-input v-model="data.vehicle_model" :error="errors.vehicle_model" label="Vehicle Model" :isLoading="loadingVin" ref="vehicleModel" :required="true"></chc-input>
        <p>In order to complete the donation more information will be required, including the vehicle's VIN and mileage. Someone can call you to complete this submission or you can continue the process online.</p>
        <div class="field radio-option">
          <input type="radio" name="complete_donation" id="call_back" value="call_back" v-model="data.complete_donation">
          <label class="inline-label" for="call_back">Call me to complete my donation</label>
        </div>
        <div class="field radio-option">
          <input type="radio" name="complete_donation" id="full_form" value="full_form" v-model="data.complete_donation">
          <label class="inline-label" for="full_form">I will complete my donation online now</label>
        </div>
        <div class="field buttons left">
          <input :disabled="isLoading || !canSubmit" @click.prevent="submit" class="btn" value="Send Donation" readonly>
        </div>
      </div>
    </form>
    <div v-if="state === 'submitted-call'">
      <p><strong>Thank you for your interest!</strong></p>
      <p>You will receive a phone call from us to complete your donation entry.</p>
      <div class="field buttons left">
        <input readonly @click.prevent="newSubmit" class="btn" value="Submit Another Donation">
      </div>
    </div>
    <div v-if="state === 'submitted-full'">
      <p><strong>Thank you for your donation!</strong></p>
      <p>A new window should have popped up with out online form for completion. Please fill it out and click the submit button. If you do not see the form you can click here to navigate to the online form or you can click below to submit a new donation request.</p>
      <div class="field buttons left widget-button">
        <input readonly @click.prevent="openFullForm" class="btn" value="Open Full Form">
      </div>
      <div class="field buttons left">
        <input readonly @click.prevent="newSubmit" class="btn" value="Submit Another Donation">
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'DonationWidgetCHC',
  data () {
    return {
      data: {
        vin: null,
      },
      isLoading: false,
      loadingVin: false,
      currentVin: null,
      errors: {},
      // form or submitted
      state: 'form',
      gtag_id: null,
      analytics_params: [],
    }
  },
  computed: {
    canSubmit () {
      var hasPhone = false
      if (this.data.no_mobile) hasPhone = this.data.phone && (this.data.phone_type === 'home' || this.data.phone_type === 'work')
      else hasPhone = this.data.mobile_phone !== null
      return (this.data.first_name && this.data.last_name &&
              this.data.email && this.data.vehicle_year &&
              this.data.vehicle_model && this.data.vehicle_make &&
              this.data.charity_id &&
              (this.data.complete_donation === 'call_back' || this.data.complete_donation === 'full_form') &&
              hasPhone)
    },
    analyticsParamsObject () {
      let params = {}
      for (let i = this.analytics_params.length - 1; i >= 0; i--) {
        params[this.analytics_params[i].key] = this.analytics_params[i].value
      }
      return params
    }
  },
  beforeRouteEnter (to, from, next) {
    Promise.all([
      store.dispatch('syncSummary'),
    ]).then(() => {
      next(vm => {
        const CHC_ANALYTICS_ID = 'UA-193029460-1'
        vm.setGtag(CHC_ANALYTICS_ID, [])
      })
    })
  },
  methods: {
    submit () {
      // this.data.submit_website = window.parent.location.href
      this.isLoading = true
      this.data.submit_website = 'true'
      if (this.data.complete_donation === 'call_back') {
        store.functions.vehicles.callBackDonation('donate',
          this.data, (error) => {
            this.errors = error
            this.isLoading = false
          }).then(() => {
          this.state = 'submitted-call'
          this.sendGtag()
          this.isLoading = false
        })
      } else if (this.data.complete_donation === 'full_form') {
        this.openFullForm()
        this.isLoading = false
      }
    },
    openFullForm () {
      this.data.submit_website = encodeURIComponent(this.data.submit_website)
      if (this.data.phone && this.data.phone_type === 'home') {
        this.data.home_phone = this.data.phone
      }
      if (this.data.phone && this.data.phone_type === 'work') {
        this.data.work_phone = this.data.phone
      }
      this.state = 'submitted-full'
      window.open(window.location.origin + '/#/full/' + window.location.hash.substr(2) + '?data=' + JSON.stringify(this.data), '_blank')
    },
    newSubmit () {
      this.data.vin = null
      this.currentVin = null
      this.data.vehicle_year = null
      this.data.vehicle_make = null
      this.data.vehicle_model = null
      this.data.vehicle_color = null
      this.data.transmission_type = null
      this.data.drive_train = null
      this.data.body_class = null
      this.data.doors = null
      this.data.complete_donation = null
      this.state = 'form'
    },
    pullVin () {
      if (this.data.vin === this.currentVin) return
      this.loadingVin = true
      store.functions.vehicles.vinInfo(this.data, (errors) => {
        this.loadingVin = false
      }).then((response) => {
        this.$refs.vehicleMake.forceUpdateValue(response.data.vehicle_make)
        this.$refs.vehicleModel.forceUpdateValue(response.data.vehicle_model)
        this.$refs.vehicleYear.forceUpdateValue(response.data.vehicle_year)
        this.data.vehicle_color = response.data.vehicle_color
        this.data.transmission_type = response.data.transmission_type
        this.data.drive_train = response.data.drive_train
        this.data.body_class = response.data.body_class
        this.data.doors = response.data.doors
        this.currentVin = this.data.vin
        this.loadingVin = false
      }).catch(() => {
        this.$refs.vehicleMake.forceUpdateValue(null)
        this.$refs.vehicleModel.forceUpdateValue(null)
        this.$refs.vehicleYear.forceUpdateValue(null)
        this.data.vehicle_color = null
        this.data.transmission_type = null
        this.data.drive_train = null
        this.data.body_class = null
        this.data.doors = null
        this.loadingVin = false
      })
    },
    setGtag (id, params) {
      this.gtag_id = id
      this.analytics_params = params
      if (id) {
        window.dataLayer = window.dataLayer || []
        window.gtag = function () {
          window.dataLayer.push(arguments)
        }
        window.gtag('js', new Date())
        window.gtag('config', id)
      }
    },
    sendGtag () {
      if (this.gtag_id) {
        window.gtag('event', 'conversion', this.analyticsParamsObject)
      }
    },
  },
  props: {
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/_variables.scss";
.widget-button {
  padding-bottom: 20px;
}

.widget-col .field {
  margin: 0 0 1.5rem;
}

.widget-col .btn {
  text-align: center;
}

.widget-short-form /deep/ .btn {
  text-align: center;
  background: $chc-grey;
  &:disabled {
    background: #ced0d0;
  }
}

.widget-short-form /deep/ {
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="tel"],
  input[type="date"],
  input[type="number"],
  input[type="time"],
  textarea {

    &:focus {
      + .field-label {
        color: $chc-grey;
      }
      &.fixed + .field-label {
        color: $chc-grey;
      }
    }
    &.fixed {
      + .field-label {
        color: $chc-grey;
      }
    }
  }
  .date-field input[type="text"] {
    &:focus {
      ~ .field-label {
        color: $chc-grey;
      }
      &.fixed ~ .field-label {
        color: $chc-grey;
      }
    }
  }
  input[type="radio"] {
    &:checked + label::before {
        background-image: radial-gradient(circle, $chc-grey 0%, $chc-grey 35%, $lt-grey 35%, $lt-grey);
    }
  }
  .icon {
    &.fa-search,
    &.fa-calendar-alt,
    &.fa-times,
    &.fa-check {
      color: $chc-grey;
    }
  }
  .checkbox {
    input[type=checkbox] {
      &:checked+label:before {
        color: $chc-grey;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Widgets/DonationWidgetCHC.vue